<script lang="ts">
  import { Icon, type IconNames } from '@shared/ui/icon';

  export let ariaLabel: string | undefined = undefined;

  export let icon: IconNames;
  export let size = 18; // default size for icons on iconButtons
  export let href: string | undefined = undefined;
  export let target: '_self' | '_blank' | '_parent' | '_top' | undefined = undefined;

  export let variant: 'primary' | 'secondary' | 'tertiary' | 'quaternary' = 'primary';

  const styles = {
    primary: 'text-black dark:text-white hover:text-default-500 dark:hover:text-white/60',
    secondary: 'text-default-600 hover:text-default-900 dark:text-dark-900 dark:hover:text-dark-800',
    tertiary: 'text-default-300 dark:text-default-400 hover:text-default-50 dark:hover:text-default-50',
    quaternary: 'text-default-900 dark:text-dark-900 transition-transform duration-150 hover:scale-125',
  };
</script>

<svelte:element
  this="{href ? 'a' : 'button'}"
  {href}
  {target}
  class="
    flex items-center
    transition-all duration-300
    {styles[variant]}
  "
  aria-label="{ariaLabel}"
  on:click
  role="button"
  tabindex="0"
>
  <Icon name="{icon}" width="{size}" height="{size}" />
</svelte:element>
